import { t } from '../../app/i18n';

export default {
  UMR: { code: 'UMR', visible: true },
  KON: { code: 'KON', visible: true },
  PODV: { code: 'PODV', visible: true },
  PRP: { code: 'PRP', visible: true}
};

export const translation = {
  UMR: t('UMR - Úmrtie klienta'),
  KON: t('KON - Konkurz klienta'),
  PODV: t('PODV – Podvod klienta'),
  PRP: t('PRP - Priebežné platby')
};



// WEBPACK FOOTER //
// ./src/common/enums/encashmentStatus.js